import { render, staticRenderFns } from "./bnbCollectionOther.vue?vue&type=template&id=1f93db68&scoped=true"
import script from "./bnbCollectionOther.vue?vue&type=script&lang=js"
export * from "./bnbCollectionOther.vue?vue&type=script&lang=js"
import style0 from "./bnbCollectionOther.vue?vue&type=style&index=0&id=1f93db68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f93db68",
  null
  
)

export default component.exports